const duration = 300;
export const defaultStyle = {
    transition: `opacity ${duration}ms ease-in-out`,
    opacity: 0,
    visibility: 'hidden',
    transform: ' translateY(20px)',
};
export const transitionStyles = {
    entering: {
        opacity: 1,
        visibility: 'visible',
        transform: ' translateY(0px)',
    },
    entered: {
        opacity: 1,
        visibility: 'visible',
        transform: ' translateY(0px)',
    },
    exiting: {
        opacity: 0,
        visibility: 'hidden',
        transform: ' translateY(20px)',
    },
    exited: {
        opacity: 0,
        visibility: 'hidden',
        transform: ' translateY(20px)',
    },
};
